import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description EuroSign icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { EuroSign } from '@sravni/design-system-icons'
 *
 * <EuroSign />
 * ```
 */
var EuroSign = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "EuroSign", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.303 4.697A7.5 7.5 0 1 1 4.697 15.303 7.5 7.5 0 0 1 15.303 4.697Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M12.947 12.947a4.166 4.166 0 1 1 0-5.893M10 8.85H5M10 11.15H5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { EuroSign };
//# sourceMappingURL=EuroSign.js.map
